import { createSlice } from "@reduxjs/toolkit";
import { getAllUsersToSpark, getDailySparks } from "./SparkThunks";

const initialState = {
    DailySparks: null,
    SparkUsers:[],
    MySparks:null,
};

const SparkSlice = createSlice({
  name: "Spark",
  initialState,
  reducers: {
    setDailySparks: (state, action) => {
      state.DailySparks = action.payload;
    },
    setSparkUsers: (state, action) => {
      state.SparkUsers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getDailySparks.fulfilled, (state, action) => {
      state.DailySparks = action.payload.amount;
      state.MySparks = action.payload.received;
    })
    .addCase(getAllUsersToSpark.fulfilled, (state, action) => {
      state.SparkUsers = action.payload;
    })
  },
});

export const { 
    setDailySparks, 
    setSparkUsers, 
    setSparkReceiver 
} = SparkSlice.actions;


export default SparkSlice.reducer;